
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/custom-select";

interface CuisineSelectorProps {
  cuisineType: string;
  onCuisineChange: (cuisine: string) => void;
}

const CUISINE_TYPES = [
  "Italian",
  "Chinese",
  "Japanese",
  "Mexican",
  "Indian",
  "Thai",
  "American",
  "Mediterranean",
  "Korean",
  "Vietnamese",
  "French",
  "Greek",
  "Spanish",
  "Middle Eastern",
  "Healthy",
  "Dessert",
  "Breakfast",
  "Other"
];

export const CuisineSelector = ({
  cuisineType = "",
  onCuisineChange,
}: CuisineSelectorProps) => {
  return (
    <Select value={cuisineType} onValueChange={onCuisineChange}>
      <SelectTrigger className="w-full h-12 rounded-xl text-black bg-[#EDEDED] border-gray-200">
        <SelectValue placeholder="Select cuisine type">
          {cuisineType || "Select cuisine type"}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-white">
        {CUISINE_TYPES.map((cuisine) => (
          <SelectItem key={cuisine} value={cuisine} className="cursor-pointer">
            {cuisine}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
